
import { defineComponent } from 'vue'
import { useExplainSearchBox } from '../../composables/explain/use-explain-search-box'

export default defineComponent({
  name: 'ExplainSearchBoxBase',
  setup() {
    useExplainSearchBox()
  },
})
